import React from "react";
import { useMedia } from "use-media";
import { connect } from "react-redux";
import logo from "../../../resources/icons/logo_reservations.svg";
import { Label } from "../../atoms/RTCC/label";
import { Link } from "../../atoms/RTCC/link";
import { useHistory } from "react-router-dom";

import './../../../resources/RTCC/css/header/header.css';

const HeaderContainer = (props) => {
    const { login, onClickOpenReservationPopupWindow } = props;
    const isWideTablet = useMedia({ maxWidth: "960px" });
    const history = useHistory();
    const onClickBack = () => {
        history.push(props.path);
    }
    const onClickIcon = () => {
        history.push("/reserve/top");
    };
    return (
        <header>
            <div className="headerBaseWrapper">
                <img onClick={onClickIcon} src={logo} className="headerBaseLeftImg" />
                <div className={props.bookedConfirmLabel ? "headerBaseRight" : "hiddenItem"} tabIndex={props.tabIndex}>
                    <Link linkTitle={props.bookedConfirmLabel} style={styles.linkLabel} onClick={() => onClickOpenReservationPopupWindow("bookConfirm", login.memberCode)} />
                </div>
            </div>
            <div className="headerBaseWrapper2" >
                <div className={isWideTablet ? "headerCenterWrapperSp" : "headerCenterWrapper"}>
                    <div className="headerLabelWrapper">
                        <div>
                    {isWideTablet && props.path ?
                        <div style={{ position: "absolute", left: 40, top: "29%", justifyContent: "center" }} onClick={onClickBack}>＜</div>
                        : null}
                            <Label label={props.categoryLabel1} className={isWideTablet ? "LabelStyleSp1" : "LabelStyle1"} />
                            <Label label={props.categoryLabel2} className={isWideTablet ? "LabelStyleSp2" : "LabelStyle2"} />
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}

const mapStateToProps = (state) => { return { login: state.login }; };
const mapToDispatchToProps = (dispatch) => {
    return {
        clearState: () => {
            dispatch({ type: "CLEAR_STATE" })
        }
    };
}
export default connect(mapStateToProps, mapToDispatchToProps)(HeaderContainer);

const styles = {
    linkLabel: {
        cursor: "pointer",
        height: "16px",
    },
    headerBaseRightLogout: {
        float: "right",
        marginTop: "0.7rem",
        marginRight: "0.7rem",
        letterSpacing: "0.05rem",
        fontWeight: 500,
    },
    headerLogout: {
        textDecoration: 'none',
        fontSize: "12px",
        textAlign: "center",
    },
}
